import React from 'react';
import { useFormContext } from 'react-hook-form';
import UiInputDate from './UiInputDate';
import UiInputMoney from './UiInputMoney';

const headerStyle: React.CSSProperties = {
    fontSize: 11,
    fontWeight: 600,
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
};

const cellStyle: React.CSSProperties = {
    padding: '0 6px',
    flex: 1,
};

export default function UiParcelasTable({ name, label = 'Configuração das Parcelas', size }: any) {
    const { watch } = useFormContext();
    const fields: any[] = watch(name) || [];
    const total = fields.length;

    return (
        <div className={`col-lg-${size || 12}`}>
            <div className="form-item">
                <label className="form-label">{label}</label>

                {fields.length === 0 ? (
                    <span style={{ fontSize: 12, color: '#999' }}>
                        Defina o número de parcelas acima.
                    </span>
                ) : (
                    <div style={{ border: '1px solid #e2e8f0', borderRadius: 6, overflow: 'hidden' }}>
                        {/* Cabeçalho */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '6px 0',
                            background: '#f8fafc',
                            borderBottom: '1px solid #e2e8f0',
                        }}>
                            <div style={{ width: 48, textAlign: 'center', ...headerStyle }}>#</div>
                            <div style={{ ...cellStyle, ...headerStyle }}>Vencimento</div>
                            <div style={{ ...cellStyle, ...headerStyle }}>Valor</div>
                        </div>

                        {/* Linhas */}
                        {fields.map((_, idx) => (
                            <div key={idx} style={{
                                display: 'flex',
                                alignItems: 'center',
                                borderBottom: idx < total - 1 ? '1px solid #f1f5f9' : 'none',
                                padding: '2px 0',
                            }}>
                                <div style={{
                                    width: 48,
                                    textAlign: 'center',
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: '#94a3b8',
                                    flexShrink: 0,
                                }}>
                                    {idx + 1}/{total}
                                </div>

                                <div style={cellStyle}>
                                    <UiInputDate
                                        asTable
                                        size={12}
                                        name={`${name}.${idx}.dataVencimento`}
                                        label="Vencimento"
                                    />
                                </div>

                                <div style={cellStyle}>
                                    <UiInputMoney
                                        asTable
                                        size={12}
                                        name={`${name}.${idx}.valor`}
                                        label="Valor"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
